import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';

import { AllAPIResponses, CarbonError } from './../../../index';
type Params = {
  id: number;
};

type Payload = {
  name: string;
};

const put = async (
  params: Params,
  payload: Partial<Payload>,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  try {
    const resp = await req.del(
      `/api/drivers/${params.id}`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 304:
        return { error: new Error('Not Modified'), response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default put;
